import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: palette.background.underBox,
      borderRadius: palette.borderRadius.default,
      alignItems: 'center',
      paddingRight: '10px'
    },
    input: {
      fontWeight: 600,
      backgroundColor: 'transparent',
      color: `${palette.text.primary}`,
      paddingLeft: '10px',
      fontSize: '16px',
      border: 'none',
      height: '30px',
      width: '100%',
      flexGrow: 1,
      '&:focus': {
        outline: 'none'
      },
      '&::placeholder': {
        color: palette.text.placeholder,
        opacity: '0.5'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
